import { useEffect, useState } from 'react';
import Axios from 'axios';
import { PATH } from '../../envs/core';

window.cacheKey = window.cacheKey || {};
window.callStack = window.callStack || [];

export default (dataPath, initialState) => {
  const [restData, setRestData] = useState(initialState);
  const path = dataPath.includes(PATH) ? dataPath : `${PATH}${dataPath}`;

  useEffect(() => {
    if (path && !path.includes('undefined')) {
      if (!window.cacheKey[path] && !window.callStack.includes(path)) {
        window.callStack.push(path);
        Axios.get(new URL(path))
          .then(response => {
            if (response.data) {
              setRestData(response.data);
              window.cacheKey[path] = response.data;
            }
          })
          .catch(() => {
            window.callStack = window.callStack.filter(item => item !== path);
          });
      } else if (!window.cacheKey[path] && window.callStack.includes(path)) {
        const chekIfDataIsReady = () => {
          if (window.cacheKey[path]) {
            setRestData(window.cacheKey[path]);
          } else if (window.callStack.includes(path)) {
            setTimeout(chekIfDataIsReady, 200);
          }
        };
        chekIfDataIsReady();
      } else {
        setRestData(window.cacheKey[path]);
      }
    }
    // eslint-disable-next-line
  }, [dataPath]);

  return restData;
};
